<template>
  <b-col>
    <b-row class="justify-content-md-center">
      <b-col md="auto">

        <b-overlay :show="loading" rounded="sm">
          <b-card
            title="Вход в систему управления"
            class="mt-3"
          >
            <b-form @submit.prevent.stop="login">
              <b-form-group
                id="username"
                label="Имя пользователя"
                label-for="username"
              >
                <b-form-input
                  id="username"
                  v-model="form.login"
                  required
                  placeholder="Введите имя пользователя"
                ></b-form-input>
              </b-form-group>

              <b-form-group id="password" label="Пароль:" label-for="password">
                <b-form-input
                  type="password"
                  id="password"
                  v-model="form.password"
                  required
                  placeholder="Введите пароль"
                ></b-form-input>
              </b-form-group>

              <b-button block type="submit" size="lg" variant="primary">
                <fa-icon icon="sign-in-alt"/> Войти
              </b-button>
            </b-form>
          </b-card>
        </b-overlay>

      </b-col>
    </b-row>
  </b-col>
</template>

<script>
import Api from "@/lib/Api";
import { store } from "@/store";

export default {
    name: 'Login',
    data () {
        return {
            appState: store.state,
            loading: false,
            form: {}
        };
    },
    methods: {
        async login () {
            this.loading = true;
            try {
                const resp = await Api.login(this.form.login,
                                             this.form.password);
                store.setAuth(resp);
                this.$router.push({name: 'main'});
                this.$root.$bvToast.toast('Авторизация успешна', {
                    title: '',
                    variant: 'success',
                    solid: true,
                });
            } catch (e) {
                console.error(e);
                var msg = 'Ошибка авторизации';
                if (e.error == 'invalid_grant' &&
                    e.error_description.indexOf('username or pass') !== -1) {
                    msg = 'Неверное имя пользователя или пароль';
                }
                this.$bvToast.toast(msg, {
                    title: 'Ошибка',
                    variant: 'danger',
                    solid: true,
                    noAutoHide: true
                });
            }
            this.loading = false;
        }
    }
}
</script>
